export default function FinancialServiceCard({ title, subtitle, icon, onClick }) {
  return (
    <button
      onClick={onClick}
      className="w-full text-left rounded-2xl border border-black/5 dark:border-white/10
                 bg-white dark:bg-slate-950
                 shadow-sm hover:shadow-md transition
                 p-4 flex items-center justify-between gap-4"
    >
      <div className="flex items-center gap-4">
        <div className="h-12 w-12 rounded-2xl bg-slate-100 dark:bg-white/10 flex items-center justify-center text-2xl">
          {icon}
        </div>
        <div>
          <div className="font-semibold text-slate-900 dark:text-white">
            {title}
          </div>
          <div className="text-sm text-slate-500 dark:text-slate-400">
            {subtitle}
          </div>
        </div>
      </div>

      <div className="h-10 w-10 rounded-xl border border-black/5 dark:border-white/10 bg-slate-50 dark:bg-white/5 flex items-center justify-center">
        <span className="text-slate-500 dark:text-slate-300">→</span>
      </div>
    </button>
  );
}
